var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.999,
    height: 145.284,
    viewBox: "0 0 99.999 145.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002C5F;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20071",
    "data-name": "Group 20071",
    transform: "translate(14675.697 768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20038",
    "data-name": "Group 20038",
    transform: "translate(-14675.696 -768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10074",
    "data-name": "Path 10074",
    className: "cls-1",
    d: "M75.793,50H58.815A41.51,41.51,0,0,0,17.3,91.511v16.982a14.154,14.154,0,0,0,14.151,14.151h71.7A14.154,14.154,0,0,0,117.3,108.494V91.511A41.51,41.51,0,0,0,75.791,50Z",
    transform: "translate(-17.304 22.639)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10075",
    "data-name": "Path 10075",
    className: "cls-1",
    d: "M92.047,33.736A31.236,31.236,0,1,1,60.81,2.5,31.237,31.237,0,0,1,92.047,33.736",
    transform: "translate(-10.81 -2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentas);
export default __webpack_public_path__ + "static/media/ventas.800e7db9aabf7d9888940fb51216100e.svg";
export { ForwardRef as ReactComponent };